// window.addEventListener("load", function() {
//     const triButton = document.querySelector(`.hero__tri-btn`);
//     const scrollLink = document.querySelector(`.hero__link--dark`);
//     const videoSection = document.querySelector(`.video`);

//     // Elements to apply click scroll event to
//     triButton.addEventListener("click", function(e) {
//         e.preventDefault();
//         videoSection.scrollIntoView({ behavior: "smooth" });
//     });

//     scrollLink.addEventListener("click", function(e) {
//         e.preventDefault();
//         videoSection.scrollIntoView({ behavior: "smooth" });
//     });
// });
